import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

export const routesWithTitles = [
  { path: '/login-check-for-outage', title: 'Outage information | Brightspeed', 
    description: "Log in to your Brightspeed account to check for outages in your area that may be affecting your service." },
  { path: '/login', title: 'My Brightspeed - Login' },
  { path: '/login-password', title: 'My Brightspeed - Login' },
  { path: '/signUp', title: 'My Brightspeed - Create account' },
  { path: '/new-forget-username', title: 'My Brightspeed - Forget username' },
  { path: '/new-forget-password', title: 'My Brightspeed - Forget Password' },
  { path: '/find-username', title: 'My Brightspeed - Forgot username' },
  { path: '/home', title: 'My Brightspeed - Home' },
  { path: '/view-payments', title: 'My Brightspeed - View payments' },
  { path: '/payment-methods', title: 'My Brightspeed - Payment methods' },
  { path: '/account-info', title: 'My Brightspeed - Account settings' },
  { path: '/plan-details', title: 'My Brightspeed - Plan details' },
  { path: '/shop-exp', title: 'My Brightspeed - Change your plan' },
  { path: '/shop-review-order', title: 'My Brightspeed - Review your service changes' },
  { path: '/update-plan', title: 'My Brightspeed - Change your plan' },
  { path: '/network-info', title: 'My Brightspeed - Network settings' },
  { path: '/help-and-support', title: 'My Brightspeed - We’re here to help' },
  { path: '/appointments', title: 'Schedule your appointment | Brightspeed' },
  { path: '/pause-service', title: 'Pause Brightspeed Service | Manage My Internet Plan' },
  { path: '/username-found', title: 'Brightspeed Username Found | Account Recovery' },
  { path: '/username-sent', title: 'Brightspeed Username Sent | Account Recovery' },
  { path: '/set-password-validate-otp', title: 'Brightspeed Security Check | Verify Your Identity' },
  { path: '/set-password-validate', title: 'Brightspeed Account Locked | Reset Your Password' },
  { path: '/set-password', title: 'Set A Password | Secure Your Brightspeed Account' },
  { path: '/new-reset-password', title: 'Set A Password | Secure Your Brightspeed Account' },
  { path: '/reset-password-confirm', title: 'Password Reset Successful | Brightspeed Account Updated' },
  { path: '/new-reset-password-confirm', title: 'Password Reset Successful | Brightspeed Account Updated' },
  { path: '/signUp-password', title: 'Set A Password | Secure Your Brightspeed Account' },
  { path: '/add-new-account', title: 'Add a Profile | Brightspeed Account Management' },
  { path: '/non-auth-quick-bill-pay', title: 'Quick Bill Pay | Brightspeed Account Lookup' },
  { path: '/non-auth-validation', title: 'Code Delivery Method | Brightspeed Security' },
  { path: '/non-auth-verify-otp', title: 'Enter One-Time Code | Brightspeed Security' },
  { path: '/agent-quick-bill-pay', title: 'Payment Method | Brightspeed Quick Bill Pay' },
  { path: '/quick-bill-payments', title: 'Payment Method | Brightspeed Quick Bill Pay' },
  { path: '/migration-appointment', title: 'Schedule your installation | Brightspeed' },
  { path: '/migration-review-order', title: 'Review and confirm your order | Brightspeed' },
  { path: '/router-appointment', title: 'Schedule your installation | Brightspeed' },
];

const getPageTitle = (pathname: string) => {
  const route = routesWithTitles.find(r => pathname?.includes(r.path.trim()));
  return route ? route.title : 'My Brightspeed';
};

const PageTitleChanger: React.FC = () => {
  const location = useLocation();
  const [announcement, setAnnouncement] = useState('');
  const isPageReload = useRef<boolean>(false);

  // Determine if the page was reloaded
  useEffect(() => {
    const navEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
    isPageReload.current = navEntry?.type === 'reload'
  }, []);  

  useEffect(() => {
    let title = getPageTitle(location.pathname);
    const element = document.getElementById('selectPayMethod');
    const content = element?.textContent || '';
    if (content.includes('Step 1')) {
      title = 'Payment Method | Brightspeed Quick Bill Pay';
    } else if (content.includes('Step 2')) {
      title = 'Review Payment | Brightspeed Quick Bill Pay';
    }
    document.title = title;
    setAnnouncement('');
    const timeout = setTimeout(() => {
      setAnnouncement(title);
    }, 100);
    return () => clearInterval(timeout);
  }, [location.pathname]);

  const pageTitle = getPageTitle(location.pathname);

  const matchedRoute = routesWithTitles.find(r =>
    location.pathname.includes(r.path.trim())
  );

  return (
    <>
    <Helmet>
      <title>{pageTitle}</title>

        {matchedRoute && (matchedRoute as any).description && (
          <meta
            name="description"
            content={(matchedRoute as any).description}
          />
        )}

    </Helmet>
      <div
        aria-live="assertive"
        aria-atomic="true"
        style={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          margin: '-1px',
          border: '0',
          padding: '0',
          clip: 'rect(0 0 0 0)',
          overflow: 'hidden',
        }}
      >
        {announcement}
      </div>
    </>
  );
};

export default PageTitleChanger;